var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#D6DFF3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 13.5C19.0916 13.5 13.5 19.0907 13.5 26V37.5234C13.5 38.0628 13.9372 38.5 14.4766 38.5H26C32.9083 38.5 38.5 32.9093 38.5 26C38.5 19.0916 32.9093 13.5 26 13.5Z",
    fill: "#1E4793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6177 30.2578C24.9029 30.2578 24.3242 30.8535 24.3242 31.5684C24.3242 32.2662 24.8859 32.8789 25.6177 32.8789C26.3496 32.8789 26.9283 32.2662 26.9283 31.5684C26.9283 30.8535 26.3326 30.2578 25.6177 30.2578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8393 20.3359C23.5416 20.3359 22.4863 21.6975 22.4863 22.6166C22.4863 23.2804 23.0479 23.5868 23.5075 23.5868C24.4266 23.5868 24.0521 22.2762 25.7882 22.2762C26.6392 22.2762 27.32 22.6507 27.32 23.4336C27.32 24.3527 26.3669 24.8803 25.8052 25.3569C25.3117 25.7824 24.6649 26.4802 24.6649 27.9439C24.6649 28.829 24.9031 29.0843 25.601 29.0843C26.435 29.0843 26.6051 28.7099 26.6051 28.3865C26.6051 27.5014 26.6222 26.9908 27.5583 26.259C28.0178 25.9016 29.4646 24.7442 29.4646 23.1443C29.4646 21.5444 28.0178 20.3359 25.8393 20.3359Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(13.5 13.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faqIcon.e907af302126d243865159568ed28bb0.svg";
export { ForwardRef as ReactComponent };